import { ResponsibleMedicalRecordRepository } from '../repositories/ResponsibleMedicalRecordRepository'

export function SetResponsibleMedicalRecordCompletedUseCase(
  repository: ResponsibleMedicalRecordRepository
) {
  return async (params: { id: string }) => {
    return await repository.setResponsibleMedicalRecordCompleted(params)
  }
}
